var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayStoreIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4401 14.8633L0.0870972 29.387C0.536411 30.9227 1.96401 32.0002 3.55963 32.0002C4.25414 32.0002 4.86214 31.8258 5.38302 31.4771L20.5775 22.7605L12.4401 14.8633Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.003 12.8195L20.4904 9.06934L13.5447 15.9584L20.5776 22.7605L27.0895 19.0979C28.2184 18.4872 29 17.2665 29 15.9584C28.9129 14.6502 28.1319 13.4295 27.003 12.8195Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 17.0913L20.491 9.0691L5.47014 0.523145C4.94926 0.174382 4.25414 0 3.55963 0C1.91049 0 0.43435 1.13379 0.0870972 2.61635L12.4102 17.0913Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0865021 2.61621C0 2.87747 0 3.22686 0 3.575V28.4285C0 28.7766 0 29.0385 0.0871245 29.3873L13.546 15.958L0.0865021 2.61621Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStoreIcon1);
export default __webpack_public_path__ + "static/media/google-play-store-icon 1.62ee326bc629802ac9708aa9006e37e2.svg";
export { ForwardRef as ReactComponent };